<template>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Activo -->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.RefActivo_1"
          label="Activo:"
          :clearable="clearcampos.RefActivo_1"
          :readonly="readcampos.RefActivo_1"
          @change="getActivos_ID()"
        ></v-text-field>
      </v-col>
      <!-- Descripcion Activo -->
      <v-col cols="12" sm="12" md="12">
        <span> Descripción: {{ editedItem.DescRefActivo_1 }}</span> <br />
        <span> Cliente del activo: {{ editedItem.Cliente }}</span>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave && editedIndex == -1"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "rca_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    ContratoID: {
      type: String,
      default: "",
      Description: "Información de documento",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    Exito: {
      type: String,
      default: "",
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        ContratoID: null,
        RefActivo_1: null,
        DescRefActivo_1: null,
        Cliente: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        ContratoID: null,
        RefActivo_1: null,
        DescRefActivo_1: null,
        Cliente: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      nactivo: true,
      clearcampos: {
        RefActivo_1: true,
      },
      readcampos: {
        RefActivo_1: false,
      },
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.ContratoID == "" ||
        this.editedItem.ContratoID == null ||
        this.editedItem.RefActivo_1 == "" ||
        this.editedItem.RefActivo_1 == null ||
        this.nactivo == true
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        this.postRegistro();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/ActivosO/R_ContratoActivo/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Get para obtener array de los activos a ombre de la persona
    async getActivos_ID() {
      if (
        this.editedItem.RefActivo_1 != "" &&
        this.editedItem.RefActivo_1 != null
      ) {
        this.ArrayActivos = [];
        this.axios
          .get("/ActivosO/Activos/CD1/" + this.editedItem.RefActivo_1)
          .then((response) => {
            this.nactivo = false;
            this.editedItem.DescRefActivo_1 = response.data[0].Descripcion;
            this.editedItem.Cliente =
              response.data[0].Document_ID_U +
              " " +
              response.data[0].DescNombre;
          })
          .catch((error) => {
            this.nactivo = true;
            this.editedItem.DescRefActivo_1 = null;
            this.editedItem.Cliente = null;
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Resetear campos
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.clearcampos.RefActivo_1 = true;
      this.readcampos.RefActivo_1 = false;
      this.nactivo = false;
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.clearcampos.RefActivo_1 = false;
        this.readcampos.RefActivo_1 = true;
        this.getActivos_ID();
      } else {
        this.editedItem.ContratoID =
          this.ContratoID != null ? this.ContratoID : null;
      }
    },
  },
  mounted() {
    this.ActualizarCargue();
  },
};
</script>
